import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logWelcomeEmailTrigger } from '../api/onboarding';
import { useOnboarding } from './OnboardingContext';

export function NotificationsStep({ stepId }) {
  const { authUser, markStepComplete } = useOnboarding();
  const [emailLogged, setEmailLogged] = useState(false);
  const [pushEnabled, setPushEnabled] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!emailLogged && authUser?.email) {
      logWelcomeEmailTrigger(authUser.email);
      setEmailLogged(true);
    }
  }, [authUser, emailLogged]);

  const handlePushRequest = () => {
    setError('');
    try {
      // TODO: Replace with real push notification request (service worker / native prompt).
      console.info('Push notification permission flow placeholder');
      setPushEnabled(true);
    } catch (err) {
      setError(err.message || 'Unable to enable notifications right now.');
    }
  };

  const finishOnboarding = () => {
    markStepComplete(stepId);
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="max-w-xl w-full bg-white rounded-3xl shadow-md p-10 border border-gray-100 space-y-6">
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900">Stay in sync</h2>
          <p className="text-sm text-gray-600">
            Get session reminders, streak updates, and AI insights delivered straight to your device.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm text-center">
            {error}
          </div>
        )}

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 space-y-3 text-sm text-gray-600">
          <p>We’ll send updates for:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>New workout drops and schedule changes</li>
            <li>Weekly progress summaries</li>
            <li>Motivational streak encouragement</li>
          </ul>
        </div>

        <div className="space-y-3">
          <button
            type="button"
            data-testid="onboarding-enable-push"
            className={[
              'w-full font-semibold px-6 py-3 rounded-xl transition-colors',
              pushEnabled ? 'bg-green-600 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white',
            ].join(' ')}
            onClick={handlePushRequest}
          >
            {pushEnabled ? 'Push Notifications Enabled' : 'Enable Push Notifications'}
          </button>
          <button
            type="button"
            data-testid="onboarding-finish"
            className="w-full bg-white border border-gray-300 hover:border-gray-400 text-gray-800 font-semibold px-6 py-3 rounded-xl transition-colors"
            onClick={finishOnboarding}
          >
            Finish & Go to Dashboard
          </button>
        </div>

        <p className="text-xs text-gray-400 text-center">
          You can change notification preferences anytime in Settings.
        </p>
      </div>
    </div>
  );
}
